export default __webpack_public_path__ + "static/media/8MarutiSuzukiCiaz.2102bae2.jpg";